import { SxProps, TableCell, TableSortLabel, Theme } from '@mui/material';
import { Dispatch, SetStateAction } from 'react';
import { HeadTableCell } from './CustomTableSortLabel.styled';

interface CustomTableSortLabelProps {
  field: string;
  sx?: SxProps<Theme>;
  label: string;
  direction: 'desc' | 'asc';
  perPage: number;
  currentPage: number;
  orderField: string;
  disableOrder?: boolean;
  handleRequest?: (
    perPage: number,
    currentPage: number,
    orderField: string,
    orderDirection: 'asc' | 'desc',
  ) => Promise<void> | undefined;
  setDirection?: Dispatch<SetStateAction<'asc' | 'desc'>>;
  setField?: Dispatch<SetStateAction<string>>;
}

const CustomTableSortLabel = (props: CustomTableSortLabelProps) => {
  const handleOrderRequest = async (field: string) => {
    let direction: 'asc' | 'desc' = props.direction === 'asc' && props.field === props.orderField ? 'desc' : 'asc';
    props.setDirection?.(direction);
    props.setField?.(field);
    await props.handleRequest?.(props.perPage || 10, props.currentPage || 0, field, direction);
  };

  return props.disableOrder ? (
    <TableCell sx={props.sx}>{props.label}</TableCell>
  ) : (
    <HeadTableCell sx={props.sx}>
      <TableSortLabel
        active={props.field === props.orderField}
        direction={props.field === props.orderField ? props.direction : 'asc'}
        onClick={() => handleOrderRequest(props.field)}
        hideSortIcon={props.field === props.orderField}
      >
        {props.label}
      </TableSortLabel>
    </HeadTableCell>
  );
};

export default CustomTableSortLabel;
